import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Fila } from '../models/fila';
import { Result } from '../models/result';
import { FilaFilter } from '../../features/fila/models/fila-filter';

@Injectable({ providedIn: 'root' })
export class FilaService {
  apiUrl = environment.urlControlCenterApi + 'fila';

  constructor(private http: HttpClient) {}

  getById(id: number) {
    return this.http.get<Result<Fila>>(`${this.apiUrl}/${id}`);
  }

  getAll() {
    return this.http.get<Result<Fila[]>>(`${this.apiUrl}`);
  }

  getFiltered(filter: FilaFilter) {
    const queryParams = [];

    if (filter.faseId) {
      queryParams.push(`fase=${filter.faseId}`);
    }

    if (filter.localId) {
      queryParams.push(`local=${filter.localId}`);
    }

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
    const url = `${this.apiUrl}/filtered` + queryString;

    return this.http.get<Result<Fila[]>>(url);
  }

  insert(data: Fila) {
    return this.http.post<Result<Fila>>(this.apiUrl, data);
  }

  update(data: Fila) {
    return this.http.put<Result<Fila>>(`${this.apiUrl}`, data);
  }

  delete(id: number) {
    return this.http.delete<Result<boolean>>(`${this.apiUrl}/${id}`);
  }
}
